import { useRef } from 'react';
import PropTypes from 'prop-types';
import { Camera } from '@phosphor-icons/react/dist/ssr/Camera';
import { IconCircleButton } from '../../../UISystem/Icons/IconCircleButton';

/**
 * CardCameraButton — the TEXT variant's card-borne camera (device pass 1
 * mock: an option, not a task — no label, no dismiss). Owns its hidden
 * capture input so list rows can each carry one; the parent owns the photo
 * spine and the retire sentinel.
 */
const CardCameraButton = ({ onFile, onTap }) => {
  const inputRef = useRef(null);
  return (
    <>
      <IconCircleButton
        icon={Camera}
        size={20}
        buttonSize={44}
        onClick={() => {
          onTap?.();
          inputRef.current?.click();
        }}
      />
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="user"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFile(file);
        }}
        style={{ display: 'none' }}
      />
    </>
  );
};

CardCameraButton.propTypes = {
  onFile: PropTypes.func.isRequired,
  onTap: PropTypes.func,
};

export default CardCameraButton;
